import { defineRouting } from 'next-intl/routing';
import { createNavigation } from 'next-intl/navigation';

export const routing = defineRouting({
  // All supported locales for bikeparkmapa
  locales: ['pl', 'en', 'de', 'cs', 'sk', 'uk'],

  // Default locale
  defaultLocale: 'pl',

  // Only show locale prefix for non-default locales
  localePrefix: 'as-needed',

  // Automatically detect user's language from browser
  localeDetection: true,

  // Localized pathnames - different URL slugs per language
  pathnames: {
    '/': '/',

    '/bikeparki': {
      pl: '/bikeparki',
      en: '/bikeparks',
      de: '/bikeparks',
      cs: '/bikeparky',
      sk: '/bikeparky',
      uk: '/bayikparky'
    },
    '/bikeparki/lista': {
      pl: '/bikeparki/lista',
      en: '/bikeparks/list',
      de: '/bikeparks/liste',
      cs: '/bikeparky/seznam',
      sk: '/bikeparky/zoznam',
      uk: '/bayikparky/spysok'
    },
    '/bikeparki/ranking': {
      pl: '/bikeparki/ranking',
      en: '/bikeparks/ranking',
      de: '/bikeparks/rangliste',
      cs: '/bikeparky/rebricek',
      sk: '/bikeparky/rebricek',
      uk: '/bayikparky/reytynh'
    },
    '/kontakt': {
      pl: '/kontakt',
      en: '/contact',
      de: '/kontakt',
      cs: '/kontakt',
      sk: '/kontakt',
      uk: '/kontakt'
    },
    '/o-nas': {
      pl: '/o-nas',
      en: '/about',
      de: '/uber-uns',
      cs: '/o-nas',
      sk: '/o-nas',
      uk: '/pro-nas'
    },
    '/jak-zaczac': {
      pl: '/jak-zaczac',
      en: '/getting-started',
      de: '/einstieg',
      cs: '/jak-zacit',
      sk: '/ako-zacat',
      uk: '/yak-pochaty'
    },
    '/sprzet': {
      pl: '/sprzet',
      en: '/gear',
      de: '/ausrustung',
      cs: '/vybaveni',
      sk: '/vybavenie',
      uk: '/obladnannya'
    },
    '/porownanie-cen': {
      pl: '/porownanie-cen',
      en: '/price-comparison',
      de: '/preisvergleich',
      cs: '/srovnani-cen',
      sk: '/porovnanie-cien',
      uk: '/porivnyannya-tsin'
    },
    '/ulubione': {
      pl: '/ulubione',
      en: '/favorites',
      de: '/favoriten',
      cs: '/oblibene',
      sk: '/oblubene',
      uk: '/ulyubleni'
    },
    '/trasy-downhill': {
      pl: '/trasy-downhill',
      en: '/downhill-trails',
      de: '/downhill-strecken',
      cs: '/downhill-trate',
      sk: '/downhill-trate',
      uk: '/downhill-trasy'
    },
    '/trasy-flow': {
      pl: '/trasy-flow',
      en: '/flow-trails',
      de: '/flow-strecken',
      cs: '/flow-trate',
      sk: '/flow-trate',
      uk: '/flow-trasy'
    },
    '/trasy-air': {
      pl: '/trasy-air',
      en: '/air-trails',
      de: '/air-strecken',
      cs: '/air-trate',
      sk: '/air-trate',
      uk: '/air-trasy'
    },
    '/pumptracki': {
      pl: '/pumptracki',
      en: '/pumptracks',
      de: '/pumptracks',
      cs: '/pumptracky',
      sk: '/pumptracky',
      uk: '/pamptraky'
    },
    '/pingwin-pass': {
      pl: '/pingwin-pass',
      en: '/pingwin-pass',
      de: '/pingwin-pass',
      cs: '/pingwin-pass',
      sk: '/pingwin-pass',
      uk: '/pingwin-pass'
    },
    '/bikepark/[slug]': {
      pl: '/bikepark/[slug]',
      en: '/bikepark/[slug]',
      de: '/bikepark/[slug]',
      cs: '/bikepark/[slug]',
      sk: '/bikepark/[slug]',
      uk: '/bikepark/[slug]'
    },
    '/trasa/[slug]': {
      pl: '/trasa/[slug]',
      en: '/trail/[slug]',
      de: '/strecke/[slug]',
      cs: '/trat/[slug]',
      sk: '/trat/[slug]',
      uk: '/trasa/[slug]'
    },
    '/pumptrack/[slug]': {
      pl: '/pumptrack/[slug]',
      en: '/pumptrack/[slug]',
      de: '/pumptrack/[slug]',
      cs: '/pumptrack/[slug]',
      sk: '/pumptrack/[slug]',
      uk: '/pumptrack/[slug]'
    },
    '/organize-trip': {
      pl: '/organizacja-wypadu',
      en: '/organize-trip',
      de: '/trip-organisieren',
      cs: '/organizace-vyletu',
      sk: '/organizacia-vyletu',
      uk: '/orhanizatsiya-podorozhi'
    },
    '/regiony': {
      pl: '/regiony',
      en: '/regions',
      de: '/regionen',
      cs: '/regiony',
      sk: '/regiony',
      uk: '/rehiony'
    },
    '/region/[slug]': {
      pl: '/region/[slug]',
      en: '/region/[slug]',
      de: '/region/[slug]',
      cs: '/region/[slug]',
      sk: '/region/[slug]',
      uk: '/region/[slug]'
    },
    '/sklep': {
      pl: '/sklep',
      en: '/shop',
      de: '/shop',
      cs: '/obchod',
      sk: '/obchod',
      uk: '/mahazyn'
    },
    '/sklep/[slug]': {
      pl: '/sklep/[slug]',
      en: '/shop/[slug]',
      de: '/shop/[slug]',
      cs: '/obchod/[slug]',
      sk: '/obchod/[slug]',
      uk: '/mahazyn/[slug]'
    },
    '/przewodnik': {
      pl: '/przewodnik',
      en: '/guide',
      de: '/leitfaden',
      cs: '/pruvodce',
      sk: '/pruvodca',
      uk: '/posibnyk'
    },
    '/przewodnik/[slug]': {
      pl: '/przewodnik/[slug]',
      en: '/guide/[slug]',
      de: '/leitfaden/[slug]',
      cs: '/pruvodce/[slug]',
      sk: '/pruvodca/[slug]',
      uk: '/posibnyk/[slug]'
    }
  }
});

// Lightweight wrappers around Next.js' navigation APIs
// that will consider the routing configuration
export const { Link, redirect, usePathname, useRouter, getPathname } =
  createNavigation(routing);
